// Settings.js
import React, { useContext, useState } from 'react';
import { Box, Text, Button, Switch, Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { getAuth, signOut } from 'firebase/auth';
import { firebase } from './firebaseConfig';
import { AuthContext } from './AuthContext';
import { Capacitor } from '@capacitor/core';
import { initNativePush } from './push-native.js';
// ...existing code...
import DeliverToDevicesCard from './DeliverToDevicesCard';
import ThemesCard from './ThemesCard';
import UserSettingsCard from './UserSettingsCard';
import { isAnalyticsEnabled, setAnalyticsEnabled, trackEvent } from './analytics';

const MotionBox = motion(Box);

const Settings = () => {
  const { user } = useContext(AuthContext);
  const [analyticsEnabled, setAnalyticsEnabledState] = useState(isAnalyticsEnabled());
  const mutedText = 'text.muted';

  const handleLogout = async () => {
    try {
      const auth = getAuth(firebase);
      await signOut(auth);
      const { fetchWithoutAuth } = await import('./apiClient');
  await fetchWithoutAuth('/firebase/logout', { method: 'POST' });
      // Optionally, you can add any post-logout logic here
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleAnalyticsToggle = (event) => {
    const enabled = event?.target?.checked ?? false;
    if (enabled) {
      trackEvent('analytics_opt_in', { source: 'settings' });
    } else {
      trackEvent('analytics_opt_out', { source: 'settings' });
    }
    setAnalyticsEnabled(enabled);
    setAnalyticsEnabledState(enabled);
  };

  return (
    <MotionBox
      p={4}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Text fontSize="2xl" mb={4}>Settings</Text>
      <ThemesCard />
      {user && (
        <>
          <DeliverToDevicesCard />
          <UserSettingsCard />
          <Box
            borderWidth="1px"
            borderRadius="xl"
            p={4}
            mt={4}
            bg="bg.surface"
            borderColor="border.subtle"
          >
            <Flex align="center" justify="space-between" gap={4} flexWrap="wrap">
              <Box>
                <Text fontSize="lg" fontWeight="semibold">Analytics</Text>
                <Text fontSize="sm" color={mutedText}>
                  Logging into Ekkos enables in-app analytics to improve reliability and performance. You can turn it off here.
                </Text>
              </Box>
              <Switch
                colorScheme="teal"
                isChecked={analyticsEnabled}
                onChange={handleAnalyticsToggle}
                aria-label="Toggle analytics"
              />
            </Flex>
          </Box>
          {Capacitor.isNativePlatform() && (
            <Button
              colorScheme="teal"
              variant="outline"
              onClick={() => {
                const apiBase = process.env.REACT_APP_BACKEND_URL;
                if (apiBase) initNativePush(apiBase, async () => {
                  const auth = getAuth(firebase);
                  const u = auth.currentUser;
                  return u ? await u.getIdToken() : null;
                });
              }}
            >
              Register Android Push (debug)
            </Button>
          )}
        </>
      )}
    </MotionBox>
  );
};

// Note: subscription logic moved into `DeliverToDevicesCard`.

export default Settings;
